jQuery(function($){
  if ($('.map-pro').length){
    var map = null;
    $('.map-pro').find('.map').each(function() {
      var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="32" viewBox="0 0 25 32"><path d="M12.311 0c-6.793 0.010-12.297 5.514-12.307 12.306v0.001c0 6.416 10.218 17.463 11.384 18.703l0.927 0.986 0.927-0.986c1.162-1.235 11.38-12.283 11.38-18.703-0.010-6.794-5.516-12.3-12.31-12.307h-0.001zM12.311 17.402c-2.814 0-5.095-2.281-5.095-5.095s2.281-5.095 5.095-5.095c2.814 0 5.095 2.281 5.095 5.095v0c-0.003 2.813-2.282 5.093-5.095 5.095h-0z"></path></svg>';
      var $map = $(this);
      map = L.map(this).setView([48.11,  -1.66], 12);
      var $pros = $map.parent().find('.pro-list__pro');
      map.scrollWheelZoom.disable();

      var pros = [];

      L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png').addTo(map);

      $pros.each(function(){
        var lon = $(this).attr('data-lon');
        var lat = $(this).attr('data-lat');
        if (Math.abs(lon)+Math.abs(lat) > 0.00001){
          var pro_id = $(this).attr('id');
          var type = $(this).attr('data-type');
          var marker = L.marker([lat, lon], {icon: L.divIcon({html: svg, iconSize: [25, 32], iconAnchor: [12.5, 32], className: "pro--"+pro_id+" type--"+type }), interactive: true });
          var pro_html = $(this).clone().html();
          pro_html = pro_html.replace(/<td/g, '<div').replace(/<\/td/g, '</div');
          marker.bindPopup('<div class="pro__popup">'+pro_html+'</div>').openPopup();
          pros.push(marker);
        }
      });

      var grouppros = L.featureGroup(pros).addTo(map);
      map.fitBounds(grouppros.getBounds(), {padding: [10, 10], maxZoom: 18});
    });

    // Form
    $('.map-search').on('submit', function(e){
      e.preventDefault();
    });

    $('.map-search__input').on('keyup change input', function(e){
      var location = $(this).val();
      if (location.length > 2){
        $('#cities').find('option').each(function(){
          if (location == $(this).val()){
            map.setView([$(this).data('lat'),  $(this).data('lon')], 12);
          }
        });
      }
    });
    $('.map-search').find('#cities').find('option').on('select', function(e){
      var location = $(this).parent().find('.map-search__input').val();
      if (location.length > 2){
        $('#cities').find('option').each(function(){
          if (location == $(this).val()){
            map.setView([$(this).data('lat'),  $(this).data('lon')], 12);
          }
        });

      }
    });

    $('.pro-list__tab').on('click', function(){
      $(this).siblings().removeClass('is-active');
      $(this).addClass('is-active');
      $('.pro-list__pros').removeClass (function (index, className) {
        return (className.match (/(^|\s)m--selected-\S+/g) || []).join(' ');
      });
      $('.pro-list__pros').addClass('m--selected-'+$(this).attr('id'));
    });
  }
});